import type { UseCase } from '@contexts/shared/application';
import type { FindAllResponse, UseCaseCriteria } from '@contexts/shared/domain';
import type { User, UserRepository } from '@contexts/users/domain';

export type FindAllUsersUseCase = UseCase<UseCaseCriteria | undefined, FindAllResponse<User>>;

export function findAllUsersBuilder(userRepository: UserRepository): FindAllUsersUseCase {
	return async function findAllUsers(criteria?: UseCaseCriteria): Promise<FindAllResponse<User>> {
		return userRepository.findAll(criteria);
	};
}
